const colors = {
  PRIMARY: process.env.VITE_COLOR_PRIMARY300 || "var(--color-primary)", // Buttons
  SECONDARY: process.env.VITE_COLOR_WHITE_BASE || "var(--color-secondary)",
  BLACK: process.env.VITE_COLOR_BLACK_BASE || "#000000",
  TEXT_PRIMARY: process.env.VITE_COLOR_BLACK_BASE || "#000000",
  TEXT_SECONDARY: process.env.VITE_COLOR_WHITE_BASE || "var(--color-secondary)",
  TEXT_BUTTON_HOVER: process.env.VITE_COLOR_PRIMARY100 || "var(--color-primary-softer)",
  NUMBER_TOP10: process.env.VITE_COLOR_PRIMARY_300 || "var(--color-primary-soft)",
  BG_BASE: process.env.VITE_COLOR_WHITE_BASE || "var(--color-secondary)",
  ERROR: process.env.VITE_COLOR_ERROR || "var(--color-danger)",
  WHITE: process.env.VITE_COLOR_WHITE_BASE || "var(--color-secondary)",
  ALTERNATIVE_WHITE: process.env.VITE_COLOR_ALTERNATIVE_WHITE || "#F3E8E8",
  GRAY: process.env.VITE_COLOR_GRAY || "var(--color-neutral-200)",
  DARK_GRAY: process.env.VITE_COLOR_DARK_GRAY || "var(--color-gray-medium-1)",
  LIGHT_GRAY: process.env.VITE_COLOR_GRAY_DARK_MODE || "#414144",
  BORDER: process.env.VITE_COLOR_BORDER || "#FFFFFF66",
  DIVIDER: process.env.VITE_COLOR_DIVIDER || "#E4E6E8",
  ORANGE: process.env.VITE_COLOR_ORANGE || "var(--color-warning)",
  BACKGROUND: process.env.VITE_COLOR_BACKGROUND || "#080a0b",
  BACKGROUND_LIGHT: process.env.VITE_COLOR_BACKGROUND_LIGHT || "#191f24",
  BACKGROUND_LIGHT_SECONDARY: process.env.VITE_COLOR_DARK_MODE100 || "var(--color-gray-medium-3)",
  COLOR_GRAY_1: process.env.VITE_COLOR_DARK_SHADES100 || "var(--color-secondary)",
  COLOR_GRAY_2: process.env.VITE_COLOR_DARK_SHADES200 || "var(--color-gray-2)",
  COLOR_GRAY_3: process.env.VITE_COLOR_DARK_SHADES300 || "var(--color-gray-3)",
  COLOR_GRAY_4: process.env.VITE_COLOR_DARK_SHADES400 || "var(--color-gray-4)",
  COLOR_GRAY_5: process.env.VITE_COLOR_DARK_SHADES500 || "var(--color-gray-5)",
  COLOR_GRAY_6: process.env.VITE_COLOR_MODAL_BACKGROUND || "var(--color-gray-6)",
  HOVER_ICONS: process.env.VITE_COLOR_HIGHLIGHT_YELLOW || "var(--color-primary-hover)",
  ANTICONS_ICONS: process.env.VITE_COLOR_ANTICONS_ICONS || "#8C8C8C",
  HOVER: process.env.VITE_COLOR_HIGHLIGHT_YELLOW || "var(--color-primary-hover)",
  AVATAR_BORDER: process.env.VITE_COLOR_AVATAR_BORDER || "#FCED28",
  ANCLAS: process.env.VITE_COLOR_ANCLAS || "#1D39C4",
  ANCLAS_HOVER: process.env.VITE_COLOR_ANCLAS_HOVER || "#061178",
  BUTTON_BACKGROUND: process.env.VITE_COLOR_PRIMARY300 || "var(--color-primary)",
  BUTTON_HOVER: process.env.VITE_COLOR_HIGHLIGHT_YELLOW || "var(--color-primary-hover)",
  BUTTON_HOVER_SECONDARY: process.env.VITE_COLOR_BUTTON_HOVER_SECONDARY || "#484848",
  BUTTON_NAVBAR: process.env.VITE_COLOR_BUTTON_NAVBAR || "#464650",
  BUTTON_NAVBAR_HOVER: process.env.VITE_COLOR_BUTTON_NAVBAR_HOVER || "#77777F",
  BUTTON_HOVER_GRADIENT: process.env.VITE_COLOR_YELLOW_GRADIENT_PRIMARY || "#FDF159",
  BUTTON_HOVER_GRADIENT_PRIMARY: process.env.VITE_COLOR_PRIMARY300 || "var(--color-primary-soft)",
  BUTTON_HOVER_GRADIENT_SECONDARY: process.env.VITE_COLOR_PRIMARY100 || "var(--color-primary-softer)",
  BUTTON_PRESSED: process.env.VITE_COLOR_BUTTON_PRESSED || "#FFB500",
  BUTTON_PRESSED_TERTIARY: process.env.VITE_COLOR_BUTTON_PRESSED_TERTIARY || "var(--color-primary-accent)",
  PLACEHOLDER: process.env.VITE_COLOR_COMPLEMENTARY100 || "#9999EB",
  COMPLEMENTARY_500: process.env.VITE_COLOR_COMPLEMENTARY500 || "var(--color-accent-hover)",
  HEADER: process.env.VITE_COLOR_DARK_BASE || "var(--color-sidebar-bg)",
  FOOTER: process.env.VITE_COLOR_DARK_BASE || "var(--color-sidebar-bg)",
  MASK_STYLE: process.env.VITE_COLOR_MASK_STYLE || "rgba(56, 56, 68, 0.8)",
  MASK_STYLE_SECONDARY: process.env.VITE_COLOR_MASK_STYLE_SECONDARY || "rgba(63, 63, 64, 0.81)",
  GRADIENT_START: process.env.VITE_COLOR_GRADIENT_START || "rgba(44,44,54,0.5)",
  GRADIENT_END: process.env.VITE_COLOR_GRADIENT_END || "rgba(44,44,54,0)",
  NONE: process.env.VITE_COLOR_NONE || "none",
  SCROLLBAR_THUMB: process.env.VITE_COLOR_SCROLLBAR_THUMB || "var(--color-gray-medium-3)",
  SCROLLBAR_THUMB_HOVER: process.env.VITE_COLOR_SCROLLBAR_THUMB_HOVER || "#5a5a66",
  SCROLLBAR_TRACK: process.env.VITE_COLOR_SCROLLBAR_TRACK || "#36363E",
  CUSTOM_NAVBAR_HOVER: process.env.VITE_COLOR_CUSTOM_NAVBAR_HOVER || "var(--color-accent)",
  CUSTOM_NAVBAR_ACTIVE: process.env.VITE_COLOR_CUSTOM_NAVBAR_ACTIVE || "var(--color-accent)",
  CUSTOM_NAVBAR_BORDER: process.env.VITE_COLOR_CUSTOM_NAVBAR_BORDER || "var(--color-accent)",
  BUTTON_CANCEL: process.env.VITE_COLOR_BUTTON_CANCEL || "#F77373",
  BUTTON_CANCEL_HOVER: process.env.VITE_COLOR_BUTTON_HOVER_CANCEL_HOVER || "#E55555",
  BUTTON_CANCEL_ACTIVE: process.env.VITE_COLOR_BUTTON_CANCEL_ACTIVE || "#D44444",
  TOOLTIP_BACKGROUND: process.env.VITE_COLOR_TOOLTIP_BACKGROUND || "var(--color-accent-lavender-soft)",
  TOOLTIP_BACKGROUND_SECONDARY: process.env.VITE_COLOR_TOOLTIP_BACKGROUND_SECONDARY || "#F77373",
  COPY_BTN_BACKGROUND: process.env.VITE_COLOR_COPY_BTN_BACKGROUND || "var(--color-accent-lavender-soft)",
  COPY_BTN_BACKGROUND_HOVER: process.env.VITE_COLOR_COPY_BTN_BACKGROUND_HOVER || "var(--color-accent-lavender)",
  GOOGLE_BUTTON_BACKGROUND: process.env.VITE_COLOR_DARK_SHADES500 || "var(--color-gray-4-alt)",
  BASE_COLOR_SECONDARY: "#F3F3F3",
};

export function injectColorsAsCSSVars() {
  const root = document.documentElement;
  Object.entries(colors).forEach(([key, value]) => {
    root.style.setProperty(`--${key.toLowerCase().replace(/_/g, "-")}`, value);
  });
}

export default colors;
